export const RegexPattern: Record<string, RegExp> = {
  EMAIL: new RegExp(
    "^[a-z\\d!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z\\d!#$%&'*+/=?^_`{|}~-]+)*@[^\\s@\\[\\]\\\\]+\\.[^\\s@\\[\\]\\\\]+$",
    'i'
  ),
  HTML: new RegExp('<[^>]+>', 'g'),
  URL: new RegExp(
    '(https?:\\/\\/(?:www\\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.\\S{2,}|www\\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.\\S{2,}|https?:\\/\\/(?:www\\.|(?!www))[a-zA-Z0-9]+\\.\\S{2,}|www\\.[a-zA-Z0-9]+\\.\\S{2,})',
    'g'
  ),
  PHONE_NUMBER_PLACEHOLDER: /[1-9][0-9]{2}-[1-9][0-9]{2}-[0-9]{4}/
};
